<div class="container-fluid">

    <div class="row">
        <div class="col-12 header-container" [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right'}">
            {{'messages.msg-recipients' | translate}}

            <button type="button" class="close" (click)="onNoClick()"  [ngStyle]="{'float': currLang == 'ar' ? 'left' : 'right'}">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
    <div class="row" style='height: 90%; padding: 50px;'>
        <div class="col-12">
            <app-table-view *ngIf="tableControls.data.length > 0" [controls]="tableControls"></app-table-view>

            <!-- <div class="table-container">
                <table class="table table-borderless">
                    <thead>
                        <tr>
                            <th scope="col">Username</th>
                            <th scope="col">National ID</th>
                            <th scope="col">Role</th>
                        </tr>
                    </thead>
                    <tbody>


                        <tr *ngFor='let recepient of data'>
                            <td>{{recepient.name}}</td>
                            <td data-pii="redact">{{recepient.national_id}}</td>
                            <td>{{getRoleLabel(recepient.roles[0].name)}}</td>
                        </tr>


                    </tbody>
                </table>
            </div> -->


        </div>
    </div>




</div>